import { t } from "i18next";

export type TBeneficiaryLanguage = { value: string; description: string };

export const Languages = () => [
    { value: "fr", description: t("Languages.fr") },
    { value: "en", description: t("Languages.en") },
];
